var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "ChatbotAiPrompt" } }, [
    _c(
      "div",
      [
        _c("h1", [_vm._v(_vm._s(_vm.$t("chatbotv2.aiPrompt")))]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n            " +
              _vm._s(_vm.$t("message.chatbotAiPromptDesc")) +
              "\n        "
          ),
        ]),
        _vm._v(" "),
        _c("a-textarea", {
          staticStyle: { "min-height": "200px" },
          attrs: {
            placeholder: _vm.$t("message.enterPrompt"),
            "auto-size": { minRows: 2 },
          },
          model: {
            value: _vm.promptText,
            callback: function ($$v) {
              _vm.promptText = $$v
            },
            expression: "promptText",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c("hr"),
    _vm._v(" "),
    _c("div", { key: _vm.key, staticClass: "parameter-tuning" }, [
      _c("h1", [_vm._v(_vm._s(_vm.$t("message.aiParameterTunings")))]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n            " +
            _vm._s(_vm.$t("message.aiParameterTuningsDesc")) +
            "\n        "
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        [
          _vm.story.ai
            ? _c("FeatureItem", {
                attrs: {
                  title: _vm.$t("message.temperature"),
                  icon: "ChatAiIcon",
                  description: _vm.$t("message.temperatureDesc"),
                  type: "number",
                  min: 0.01,
                  max: 2,
                  step: 0.1,
                  "number-format": "float",
                },
                on: {
                  blur: function ($event) {
                    return _vm.changeTemperature(_vm.temperature)
                  },
                  increase: function ($event) {
                    return _vm.changeTemperature(_vm.temperature)
                  },
                  decrease: function ($event) {
                    return _vm.changeTemperature(_vm.temperature)
                  },
                },
                model: {
                  value: _vm.temperature,
                  callback: function ($$v) {
                    _vm.temperature = $$v
                  },
                  expression: "temperature",
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _vm.story.ai
            ? _c("FeatureItem", {
                attrs: {
                  title: "Top-P",
                  icon: "ChatAiIcon",
                  description: _vm.$t("message.topDesc"),
                  type: "number",
                  min: 0.01,
                  max: 1,
                  step: 0.1,
                  "number-format": "float",
                },
                on: {
                  blur: function ($event) {
                    return _vm.changeTopP(_vm.topP)
                  },
                  increase: function ($event) {
                    return _vm.changeTopP(_vm.topP)
                  },
                  decrease: function ($event) {
                    return _vm.changeTopP(_vm.topP)
                  },
                },
                model: {
                  value: _vm.topP,
                  callback: function ($$v) {
                    _vm.topP = $$v
                  },
                  expression: "topP",
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _vm.story.ai
            ? _c("FeatureItem", {
                attrs: {
                  title: _vm.$t("chatbotv2.aiListenerDelay"),
                  icon: "ChatAiIcon",
                  description: _vm.$t("chatbotv2.aiListenerDelayDesc"),
                  type: "number",
                  min: 5000,
                  max: 60000,
                  step: 1000,
                  "number-format": "integer",
                },
                on: {
                  blur: function ($event) {
                    return _vm.changeAiListenerTimeout(_vm.aiListenerTimeout)
                  },
                  increase: function ($event) {
                    return _vm.changeAiListenerTimeout(_vm.aiListenerTimeout)
                  },
                  decrease: function ($event) {
                    return _vm.changeAiListenerTimeout(_vm.aiListenerTimeout)
                  },
                },
                model: {
                  value: _vm.aiListenerTimeout,
                  callback: function ($$v) {
                    _vm.aiListenerTimeout = $$v
                  },
                  expression: "aiListenerTimeout",
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "modes" }, [
        _c("strong", [
          _vm._v(" " + _vm._s(_vm.$t("message.toolChoices")) + " "),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { key: _vm.key, staticClass: "mode-items" },
          [
            _vm.story.ai
              ? _c("FeatureItem", {
                  attrs: {
                    title: _vm.$t("whatsapp_business_api.none"),
                    icon: "ChatAiIcon",
                    description: _vm.$t("message.noneDesc"),
                    type: "switch",
                  },
                  model: {
                    value: _vm.toolChoiceNone,
                    callback: function ($$v) {
                      _vm.toolChoiceNone = $$v
                    },
                    expression: "toolChoiceNone",
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.story.ai
              ? _c("FeatureItem", {
                  attrs: {
                    title: _vm.$t("chatbotv2.auto"),
                    icon: "ChatAiIcon",
                    description: _vm.$t("message.autoDesc"),
                    type: "switch",
                  },
                  model: {
                    value: _vm.toolChoiceAuto,
                    callback: function ($$v) {
                      _vm.toolChoiceAuto = $$v
                    },
                    expression: "toolChoiceAuto",
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.story.ai
              ? _c("FeatureItem", {
                  attrs: {
                    title: _vm.$t("message.required"),
                    icon: "ChatAiIcon",
                    description: _vm.$t("message.requiredDesc"),
                    type: "switch",
                  },
                  model: {
                    value: _vm.toolChoiceRequired,
                    callback: function ($$v) {
                      _vm.toolChoiceRequired = $$v
                    },
                    expression: "toolChoiceRequired",
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "settings-btn" },
      [
        _c(
          "SupsisButton",
          { attrs: { ghost: "" }, on: { click: _vm.clearPrompt } },
          [_vm._v(" " + _vm._s(_vm.$t("message.cancel")))]
        ),
        _vm._v(" "),
        _c(
          "SupsisButton",
          { attrs: { primary: "" }, on: { click: _vm.updatePrompt } },
          [_vm._v(_vm._s(_vm.$t("message.save")))]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }